import { render } from "./Meeting.vue?vue&type=template&id=17872be0"
import script from "./Meeting.vue?vue&type=script&lang=js"
export * from "./Meeting.vue?vue&type=script&lang=js"
script.render = render

export default script